<template>
  <div class="select_font_size">
    <div :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" :style="{ width: titleWidth+ 'px' }"></span>
      <div class="select_font_size_box">
        <span
          class="module select_font_size_text"
          :style="{ width: width + 'px' }"
          @click="focus_input"
        >
          <el-input
            class="select_input"
            :style="{ width: width - 30 + 'px' }"
            ref="font_input"
            v-if="isShowInput"
            v-model="inputResult"
            size="small"
            @change="change_select_input"
            @input="input_select_input"
            @keyup.enter.native="change_select_input"
          ></el-input>
          <span v-else>{{ Result }}px</span>
        </span>
        <el-select
          :style="{ width: width + 'px' }"
          class="module"
          v-model="Result"
          :placeholder="placeholder"
          :disabled="disabled"
          size="small"
          @change="change"
          @visible-change="visible_change"
          :automatic-dropdown="true"
          ref="font_select"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            @click.native="change"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'select_font_size',
  props: {
    title: { // 组件的标题
      type: String,
      default: ''
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: { // 输入框的值
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: { // 数组
      type: Array,
      default: function () {
        return []
      }
    },
    width: {
      type: String,
      default: '118'
    },
    titleWidth: {
      type: String,
      default: '40'
    }
  },
  watch: {
    Result (val) {
      this.$emit('update:value', val);//双向数据绑定
    },
    value (val) {
      this.Result = this.value
    }
  },
  data () {
    return {
      Result: this.value,
      inputResult: this.value,
      inputResultTemp: this.value,
      isShowInput: false
    }
  },
  methods: {
    change () {
      this.isShowInput = false
      this.inputResult = Number(this.Result)
      this.$emit('change', this.Result)
    },
    focus_input () {
      this.isShowInput = true
      this.$nextTick(() => {
        this.$refs.font_select.focus()
        this.$refs.font_input.focus()
        this.$refs.font_input.select()
      })

    },
    change_select_input (val) {
      let num = Number(this.inputResult)
      this.isShowInput = false
      this.inputResult = num
      this.inputResultTemp = num
      if (num < 12) {
        this.inputResult = 12
        this.inputResultTemp = 12
      }
      this.Result = this.inputResult
      this.$refs.font_select.blur()
      this.$emit('change', this.Result)
    },
    input_select_input (val) {
      let inputResult = val
      if (!isNaN(Number(inputResult)) || inputResult === '') {
        this.inputResult = inputResult
        this.inputResultTemp = inputResult
        if (Number(inputResult) > 120) {
          this.inputResult = 120
          this.inputResultTemp = 120
        }
      } else {
        this.inputResult = this.inputResultTemp
      }
    },
    visible_change (val) {
      if (val) {
        $(".main_dialog").draggable('disable')
      } else {
        this.isShowInput = false
        $(".main_dialog").draggable('enable')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select_font_size {
  .select_font_size_box {
    position: relative;
    .select_font_size_text {
      position: absolute;
      z-index: 1;
      padding: 0 30px 0 15px;
      height: 100%;
      font-size: 13px;
      cursor: pointer;
      /deep/ .select_input {
        position: absolute;
        left: 0;
        z-index: 2;
        .el-input__inner {
          padding: 0;
          text-align: center;
          border-color: transparent;
          background: transparent;
        }
      }
    }
    /deep/ .el-select {
      .el-input__inner {
        color: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_font_size/components/select_font_size.vue